import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';

import styles from './Hero.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

const HERO_IMAGE = '/images/services_marketplace/home/hero_image.jpg';
const HERO_IMAGE_2X = '/images/services_marketplace/home/hero_image@2x.jpg';

function Hero({i18n}: CombinedProps) {
  return (
    <div className={styles.Hero}>
      <div className={styles.TextContainer}>
        <h1 className={styles.Text}>{i18n.translate('Home.Hero.text')}</h1>
      </div>
      <div className={styles.ImageContainer}>
        <img
          className={styles.Image}
          src={HERO_IMAGE}
          srcSet={`${HERO_IMAGE} 1x, ${HERO_IMAGE_2X} 2x`}
          alt=""
        />
      </div>
    </div>
  );
}

export default withI18n()(Hero);
